import {globalColorsNBD, mainThemeColorsNBD} from '@volkswagen-onehub/tokens'

export const CARD_BORDER_COLOR = globalColorsNBD.newHorizon['100']

export const CARD_EMPHASIS_BACKGROUND = `linear-gradient(167deg, ${globalColorsNBD.white['80']} 0%, ${globalColorsNBD.white['20']} 60%, ${globalColorsNBD.white['00']} 100%)`

export const CARD_BACKGROUND = globalColorsNBD.white['100']

export const CARD_SHADOW_DEFAULT = mainThemeColorsNBD.shadow.default

export const CARD_SHADOW_SMALL = mainThemeColorsNBD.shadow.small
